 
<div class="popover" [ngClass]="context === 'triage' ? 'triage-popover' : 'backlog-popover'">
    <div class="input-group p-2 pb-0">
      <input type="text" name="labelSearch" id="labelSearch" class="form-control mb-1" 
            [formControl]='searchCtrl'
            (keydown.enter)="enterSearch()"
            placeholder="{{ 'task_label.search' | translate}}">
      <span class="icon-addon bg-white">  
        <i class="far fa-search"></i>
      </span>
    </div>
    
    <div class="popover-content">
      <!-- Libellés disponibles -->
      <div class="label-group">
        <div class="label-group-title">{{'task_label.popover.label' | translate}}</div>
        @for(label of filteredLabels; track label.id){
          <div class="label-item" [ngClass]="setSelectedClass(label)">
              <div class="d-flex align-items-center" (click)="toggleLabel(label)">
                <div>
                  <i class="fa-regular fa-square pe-2"></i>
                  <i class="fa-regular fa-square-check pe-2"></i>
                </div>
                <div>
                  {{ label.name }}
                  <span class="ps-2 label-color" [style.background-color]="label.color"></span>
                </div>
              </div>
              <div class="text-secondary">
                <span (click)="editLabel(label)" class="pe-2">
                  <i class="fa-regular fa-pen-to-square"></i>
                </span>
                <span (click)="deleteLabel(label)">
                  <i class="fa-regular fa-xmark"></i>
                </span>
              </div>
           
          </div>
        }
        <div>
          <button class="btn btn-add-label" (click)="addLabel()" [disabled]="availableLabels.map(label => label.name).indexOf(searchCtrl.getRawValue()) !== -1">{{ 'task_label.popover.new' | translate }}</button>
        </div>
      </div>
    </div>

    <div class="popover-footer">
      @if(context === 'triage'){
        @if(selectedLabels.length > 0){
          <button class="btn w-100 btn-primary" (click)="applyLabels(selectedLabels)">{{ 'task_label.popover.keep_with_label' | translate }}</button>
        }@else {
          <button class="btn w-100 btn-outline-primary" (click)="applyLabels(selectedLabels)">{{ 'task_label.popover.keep_without_label' | translate }}</button>
        }
      }
      @if(context === 'backlog'){
        <button class="btn w-100 btn-primary" (click)="applyLabels(selectedLabels)">{{ 'task_label.popover.apply' | translate}}</button>
      }
    </div>
</div>
   